var bgTextCardsManager = (function () {
    var components = $('.bg-text-cards-component');
    function init() {
        $(document).ready(function () {
            if (components.length) {
                initMainCarousel();
            }
        })
        $( window ).resize(function () {
            if (components.length) {
                initMainCarousel();
            }
        });
    }

    function initMainCarousel() {

        components.each(function () {
            var carousel = $(this).find('.owl-carousel');

            if (carousel.length>0){
                carousel.owlCarousel({
                    navText: [
                        "<i class='previous fa fa-arrow-left'></i>",
                        "<i class='next fa fa-arrow-right'></i>"
                    ],
                    dots: false,
                    center: false,
                    loop: false,
                    margin: 30,
                    responsive:{
                        0:{
                            nav: false,
                            items: 1.4,
                        },
                        576:{
                            nav: true,
                            items: 3,
                            stagePadding: 0
                        }
                    },
                    onInitialized: function (e) {
                        var target = $(e.target);
                        var navs = target.find('.owl-nav:not(.disabled)');
                        if (navs.length>0){
                            navs.find('.owl-prev').attr('title',LABELS.previous).attr('aria-label',LABELS.previous).removeAttr('role');
                            navs.find('.owl-next').attr('title',LABELS.next).attr('aria-label',LABELS.next).removeAttr('role');
                        }
                        var maxHeight = 0;
                        var items = target.find('.item');
                        items.each(function () {
                            maxHeight = Math.max(maxHeight,$(this).height());
                        })
                        items.height(maxHeight)
                    }
                })
            }
        })
    }

    return {
        init: init
    };
})(jQuery);
